import { Injectable } from '@angular/core';
import { MenuItemBase } from '../../core-module/models/menu-item';
import { AccountService } from '../../core-module/services/account.service';
import { JwtTokenService } from './jwt-token.service';
import { UserRole } from '../../core-module/models/role';



@Injectable({
    providedIn: 'root'
})
export class MenuHelperService {

    constructor(
        private jwtTokenService: JwtTokenService,
        private accountService: AccountService
    ) { }

    /**
     * Checks if the current user has access to a menu item based on roles and permissions
     * @param item The menu item to check access for (must have roles and/or permissions properties)
     * @returns True if the user has access (either through roles OR permissions)
     */
    hasAccessToItem<T extends MenuItemBase>(item: T): boolean {
        if ((!item.permissions || item.permissions.length == 0) && (!item.roles || item.roles.length == 0))
            return true;

      // Check if user has required roles
      const hasRoles = this.jwtTokenService.hasAnyRoles((item.roles || []) as UserRole[]) || (item.roles || []).length === 0;

        // Check if user has required permissions
        let hasPermissions = false;
        if (item.permissions && item.permissions.length > 0) {
            hasPermissions = item.permissions.some(permission => this.accountService.hasPermission(permission));
        }

        // User has access if they have either the required roles OR the required permissions
        return hasRoles || hasPermissions;
    }

    /**
     * Filters an array of menu items to only include those the user has access to
     * @param items Array of menu items to filter
     * @returns Filtered array containing only accessible menu items
     */
    filterAccessibleItems<T extends MenuItemBase>(items: T[]): T[] {
        return items
            .filter(item => this.hasAccessToItem(item))
            .map(item => {
                // If item has subItems, recursively filter them
                if ('subItems' in item && Array.isArray(item.subItems) && item.subItems.length > 0) {
                    return {
                        ...item,
                        subItems: this.filterAccessibleItems(item.subItems)
                    };
                }
                return item;
            });
    }
}
